var postURI = 'https://ironcity.smarthost.eu/ironcity.php';

function partstreamAddToCart(data){
	
	var sku = '';
	try
	{
		sku = unescape(data).split("arisku=")[1].split("&")[0];
	}
	catch (e)
	{
		console.log(e);
	}

	jQuery.post(postURI, {"data": data}, function(r){ //success
		ret=JSON.parse(r);
		if (ret['id']>0){
			//Add to cart
            jQuery("a.add-to-cart").attr("id", ret['id']);		
            jQuery("a.add-to-cart").attr("rel", ret['quantity']);
            jQuery("a.add-to-cart").click();
						
		}
		else{
			psbox("Product not available");
		}
				
		
	});			
}


function psbox(prname){
	jQuery("#ps-add").remove();
	jQuery('<div id="ps-add" ><div><h5 id="ps-product">'+ prname + '</h5></div><div id="ps-buttons"><button  class="btn" id="ps-cancel" onclick="pscancel();">Close</button></div></div>').insertBefore("#ariPartStream");
}

function pscancel(){
	jQuery("div#ps-add").remove();
}

